/** Abc Types */
export const GET_ABCS = 'GET_ABCS';
export const GET_ABCS_SUCCESS = 'GET_ABCS_SUCCESS';

export const GET_ABC_BY_ID = 'GET_ABC_BY_ID';
export const GET_ABC_BY_ID_SUCCESS = 'GET_ABC_BY_ID_SUCCESS';

export const CREATE_ABC_MANUAL = 'CREATE_ABC_MANUAL';
export const CREATE_ABC = 'CREATE_ABC';
export const EDIT_ABC = 'EDIT_ABC';
export const DELETE_ABC = 'DELETE_ABC';

/** End */
